<template>
    <website-page>
        <restauration-navigation/>
        <div class="main-section overlay">
            <b-container>
                <h1 class="blured">
                    <div v-tr>Digital Signage for|L'affichage numérique</div>
                    <div v-tr>Restaurants and Quick Service Restaurants|pour la restauration rapide et les restaurants</div>
                </h1>
                <h3 class="subtitle blured" v-tr>
                    More than 20 years of expertise in providing Digital Solutions for Restaurants|
                    Plus de 20 d'expertise dans l'affichage numérique pour les restaurants
                </h3>
                <p class="presentation" v-tr>
                    Did you know that Eye-In was the first provider of Digital Signage for McDonald in Canada? Our solution includes Digital Menuboard, Entertainment TV, Self-Ordering Kiosks and much more!|
                    Saviez-vous qu'Eye-In a été le premier fournisseur d'affichage numérique pour McDonald au Canada ? Notre solution comprend aussi bien les menus numériques, la télévision de divertissement, les kiosques de commande automatique et bien plus encore !
                </p>
                <b-row class="mt-5">
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/mc_donald.png')" alt="Client  Digital Signage McDonald"/>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/mc_cafe.png')" alt="Client Digital Signage McCafé"/>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/mty.png')" alt="Client QSR MTY"/>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/thai-express.png')" alt="Client Quick Service Restaurant Thai Express"/>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/tcby.png')" alt="Client Iced Yogurts TCBY"/>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/cultures.png')" alt="Client Restaurant Cultures"/>
                    </b-col>
<!--                    <b-col cols="6" md="4" xl="2" class="client">-->
<!--                        <b-img :src="require('../../assets/img/clients-white/cegep_beauce_appalache.png')" alt="Client Digital Cegep Beauce Appalache"></b-img>-->
<!--                    </b-col>-->
                </b-row>
                <div class="mt-5">
                    <b-btn v-scroll-to="'#contact-us'" class="mr-2" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                    <b-btn  v-if="!isMobileLayout"  v-scroll-to="'#testimonials'" variant="outline-light"><span v-tr>OTestimonials|Témoignages</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="testimonials" class="page inverted">
            <b-container>
                <h3 class="text-center" v-tr>Testimonials|Témoignages</h3>
                <template v-if="isFrench">
                    <testimonial-card name="Grant Dedeyan" client-since="2012" alt="Boulangerie Arouch Grand Dedeyan témoignage"
                                      job="Propriétaire Boulangerie Arouch"
                                      :src="require('../../assets/img/clients-color/restauration/arouch.png')">
                        Notre expérience avec Eye-In Media a été très professionnelle et satisfaisante sur 3 ans, donc pour nos 4 sites. Ils ont toujours fait preuve d’un excellent service client et d’un excellent support technique.
                        Nous continuerons certainement à faire affaire avec Eye-In Media pour nos futurs emplacements et le recommanderons à notre réseau d'amis cherchant à améliorer leur menu numérique.
                    </testimonial-card>
                    <testimonial-card name="Pierre Brunet" client-since="2005" alt="McDonald's franchisé Pierre Brunet témoignage"
                                      job="Propriétaire de 10 établissements McDonald's au Québec"
                        :src="require('../../assets/img/clients-color/restauration/mc_donalds.jpg')">
                        Depuis le début de notre relation d’affaires , vous nous avez ouvert des horizons jamais exploités par le passé avec notre clientèle , votre créativité en technologie ainsi que votre persévérance a assuré notre succès et est la raison pour laquelle vous serez toujours un de nos partenaires médiatiques de premier choix.
                        Merci et félicitations à toute l’équipe !
                    </testimonial-card>
                    <testimonial-card name="Albert Levy" client-since="2008" alt="McDonald's franchisé Albert Levy témoignage"
                                      job="Franchisé et propriétaire de plusieurs établissements McDonald’s"
                        :src="require('../../assets/img/clients-color/restauration/mc_donalds.jpg')">
                        C'est avec grand plaisir que je voudrais recommander sans réserve et vanter les services offerts par Eye-In Media. Mon entreprise utilise les services de Eye-In depuis plus de 7 ans. Je suis impressionné par la qualité de leur service, l'efficacité de ses techniciens ainsi que le fait de pouvoir compter sur eux.
                        Félicitations à Nathalie Azoulay et toute son équipe.
                    </testimonial-card>
                </template>
                <template v-else>
                    <testimonial-card name="Fred Cassir" client-since="2008" alt="McDonald's Franchisee Fred Cassir Testimonial"
                                      job="Franchisee McDonald’s"
                                      :src="require('../../assets/img/clients-color/restauration/mc_donalds.jpg')">
                        Eye-In Media is a long time partner of McDonald's Restaurants in Quebec, our relationship is one of trust, creativity and Brand building. The team at Eye-In Media is efficient, professional and competent assuring a seamless high quality broadcast. The added benefit is the direct one on one exchange with the owners.
                    </testimonial-card>
                    <testimonial-card name="Grant Dedeyan" client-since="2012" alt="Boulangerie Arouch Grand Dedeyan Testimonial"
                                      job="Owner Boulangerie Arouch Inc"
                                      :src="require('../../assets/img/clients-color/restauration/arouch.png')">
                        Our experience with Eye-In Media has been highly professional and satisfying over the course of 3 years, thus for our 4 locations. They have always shown great customer service and technical support.
                        We would definitely continue doing business with Eye-In Media for our future locations and recommend it to our network of friends seeking to enhance their digital menu.
                    </testimonial-card>
                    <testimonial-card name="Jonathan Dresner" client-since="2012" alt="Double Pizza Jonathan Dresner Testimonial"
                                      job="Vice-President Double Pizza & Roasters Express"
                                      :src="require('../../assets/img/clients-color/restauration/double_pizza.png')">
                        Eye-In-Media has done a great job in providing us a turn key solution for digital menu from the set up to artwork. The technical support team is efficient and the upper management is superb. We met many other companies before and have many other companies knocking at our door but none of them seem capable of competing all around with what Eye-In-Media is providing.
                    </testimonial-card>
                </template>
            </b-container>

            <div class="text-center">
                <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#clients'" variant="outline-light"><span v-tr>They Chose Us|Ils nous ont choisis</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
            </div>
        </div>

        <div id="clients" class="page bg-light">
            <b-container>
                <h3 class="text-center mb-3" v-tr>They chose us|Ils nous ont choisis</h3>
                <signage-restauration-client-cards></signage-restauration-client-cards>
            </b-container>
        </div>
    </website-page>
</template>

<script>
    import SignageRestaurationClientCards from "@/client-cards/signage-restauration-client-cards.vue";
    import RestaurationNavigation from "@/navigation/restauration-navigation.vue";
    import {isFrench, translate} from "../../../vue-components/helpers/i18n.js";

    export default {
        name: `digital-signage-clients`,
        components: {
            SignageRestaurationClientCards,
            RestaurationNavigation},
        metaInfo: {
            title: translate(`Eye-In Clients in Digital Signage|Clients Eye-In dans l'affichage numérique`),
            meta: [
                { name: `keywords`, content: `clients, digital, signage, menu board, video wall, menuboard, videowall, retail, restaurants, healthcare, education, school, universities, shopping mall` },
                { name: `description`, content: translate(`Eye-In Media : Digital Signage for Healthcare, Restauration, Retail, Education|Eye-In Media : l'affichage numérique pour la santé, la restauration, la vente au détail et l'éducation`) }
            ]
        },
        data() {
            return {
                isFrench: isFrench()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-section {
        background-color: #151e28;
        background-image: url('../../assets/img/backgrounds/restauration-kitchen.webp');
        background-size: cover;
    }

    .icon-list {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .fal,
        .fas {
            opacity: 0.8;
            font-size: 36px;
            padding: 15px;
            display: inline-flex;
            margin: 0 auto;
        }
    }
</style>
